import React from 'react'
import Card from 'components/common/Card'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { BenefitTypeNames } from 'consts/coverageBenefitsConsts'
import './ProviderResourceLink.css'
import SSOAlert from 'components/common/SSOAlert/SSOAlert'

const ProviderResourceLink = ({ title, link, customAction }) => {
  const isAuthenticated = useSelector(state => state.auth.isLoggedIn)
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const [popupLink, setPopupLink] = useState(null)
  const [popupTitle, setPopupTitle] = useState(null)

  const handleClick = () => {
    if (customAction && isAuthenticated) {
      switch (customAction) {
        case `popup-${BenefitTypeNames.VISION}`: {
          setPopupTitle(BenefitTypeNames.VISION)
          setPopupLink(link)
          setIsPopupVisible(true)
          break
        }
        case `popup-${BenefitTypeNames.DENTAL}`: {
          setPopupTitle(BenefitTypeNames.DENTAL)
          setPopupLink(link)
          setIsPopupVisible(true)
          break
        }
        default: {
          window.open(link, '_blank')
        }
      }
    } else if (link) {
      window.open(link, '_blank')
    }
  }

  return (
    <>
      <Card
        className='provider-resource-link-card trackable'
        data-name={title}
        onClick={handleClick}
      >
        <div className='provider-resource-link-container'>
          <div className='provider-resource-link-title'>
            <h2>{title}</h2>
          </div>
          <i className='icon-export'></i>
        </div>
      </Card>
      <SSOAlert
        isSSONoteVisible={isPopupVisible}
        setIsSSONoteVisible={setIsPopupVisible}
        ssoLink={popupLink}
        ssoLinkName={popupTitle}
      />
    </>
  )
}

export default ProviderResourceLink
